﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20Contract = void 0;
const ERC20ABI_1 = require("./abi/ERC20ABI");
const ContractFacade_1 = require("./abstact/ContractFacade");
class ERC20Contract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, ERC20ABI_1.ERC20ABI.GetABI());
    }
    name() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._call("name");
        });
    }
    symbol() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._call("symbol");
        });
    }
    totalSupply() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("totalSupply");
            return this._toDecimal(res);
        });
    }
    transfer(to, amountEth) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('transfer', to, this._web3.utils.toWei(amountEth, "ether"));
        });
    }
    approve(spenderAddr, amountEth) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('approve', spenderAddr, this._web3.utils.toWei(amountEth, "ether"));
            return result;
        });
    }
    balanceOf(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("balanceOf", address);
            return this._toDecimal(res);
        });
    }
}
exports.ERC20Contract = ERC20Contract;
//# sourceMappingURL=ERC20Contract.js.map